export default "__VITE_ASSET__B9XGTk$X__"